import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PAYMENT_TERM } from "./apiRoutes";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getPaymentTermsByCommunity = async (communityId: string) => await axiosAuth.get(`${PAYMENT_TERM}/community/${communityId}`);

const useGetPaymentTermsByCommunity = ({communityId, queryParams}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-Term", communityId],
    queryFn: () => getPaymentTermsByCommunity(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPaymentTermsByCommunity;
